// extracted by mini-css-extract-plugin
export default {"cls1":"SignupBanner-cls1_Cf9","cls2":"SignupBanner-cls2_Tri SignupBanner-cls1_Cf9"};